import { applicationFields } from '../config/applicationConfig';

export const collectFormData = (formContextData, newStepData = {}) => {
  const mergedData = { ...formContextData, ...newStepData };

  // Collect all known field names (flat fields only)
  const allFieldNames = new Set();

  applicationFields.forEach(step => {
    step.fields.forEach(field => {
      if (field.name) allFieldNames.add(field.name);

      if (field.conditional?.fields?.length) {
        field.conditional.fields.forEach(subField => {
          if (subField.name) allFieldNames.add(subField.name);
        });
      }

      if (field.fields?.length) {
        field.fields.forEach(nestedField => {
          if (nestedField.name) allFieldNames.add(nestedField.name);
        });
      }
    });
  });

  // Merge full known fields + preserve extras like arrays
  const fullPayload = { ...mergedData };

  allFieldNames.forEach(fieldName => {
    if (!(fieldName in fullPayload)) {
      fullPayload[fieldName] = '';
    }
  });

  return fullPayload;
};
